<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <a-radio-group v-model="alertTime">
        <a-radio-button value="24h">{{ $t('system.near_24h') }}</a-radio-button>
        <a-radio-button value="7d">{{ $t('system.near_7d') }}</a-radio-button>
        <a-radio-button value="30d">{{ $t('system.near_30d') }}</a-radio-button>
      </a-radio-group>
    </div>
    <vxe-grid
      row-id="id"
      ref="tableRef"
      max-height="500"
      resizable
      show-overflow
      show-header-overflow
      :columns="tableColumns"
      :data="tableData"
      :scroll-x="{gt:3}"
      @checkbox-all="selectAllChangeHandle"
      @checkbox-change="selectChangeHandle">
      <template #pager>
        <vxe-pager
          :layouts="['PrevJump', 'PrevPage', 'Jump', 'PageCount', 'NextPage', 'NextJump', 'Total']"
          :current-page.sync="tablePage.currentPage"
          :page-size.sync="tablePage.pageSize"
          :total="tablePage.total"
          @page-change="handlePageChange" />
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import _ from 'lodash'
import { getCopyWithContentTableColumn } from '@/utils/common/tableColumn'
import i18n from '@/locales'
import { getWorkflowParamter } from '@/utils/utils'
import { alertResourceTypeMap } from '../constants'
import { getLevelTableColumn, getAlertCountTableColumn, getStateTableColumn, getAlertInfoTableColumn } from '../utils/columns'

export default {
  name: 'AlertList',
  components: {
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    variables: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      alertTime: '24h',
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
      },
      tableData: [],
    }
  },
  computed: {
    tableColumns () {
      const ret = [
        getCopyWithContentTableColumn({
          field: 'id',
          title: i18n.t('common_350'),
          minWidth: 80,
        }),
        {
          field: 'alert_resource',
          title: this.$t('monitor.text_17'),
          slots: {
            default: ({ row }, h) => {
              const config = getWorkflowParamter(row.variables)
              let resource = {}
              if (config.data?.tags) {
                resource = config.data.tags
              }
              let nameKey = 'data.tags.name'
              if (alertResourceTypeMap[config.res_type]) {
                nameKey = alertResourceTypeMap[config.res_type].nameKey
              }
              const name = _.get(config, nameKey) || resource.name || ''
              return [
                <div class='text-truncate'>
                  <span class="mr-2">{ name || '-' }</span>
                </div>,
              ]
            },
          },
        },
        getLevelTableColumn(),
        getAlertCountTableColumn(),
        getStateTableColumn(),
        getAlertInfoTableColumn(),
      ]
      return ret
    },
  },
  watch: {
    alertTime () {
      this.tablePage.currentPage = 1
      this.getAlertList()
    },
  },
  created () {
    this.getAlertList()
  },
  methods: {
    handleUpdate (data) {
      this.$emit('refresh', data)
    },
    getAlertList (offset = 0) {
      new this.$Manager('historic-process-instances').list({
        params: {
          scope: this.$store.getters.scope,
          details: true,
          limit: this.tablePage.pageSize,
          offset,
          alert_id: this.variables.alert_id,
          metric: this.variables.metric,
          monitor_resource_id: this.variables.monitor_resource_id,
          filter: [`create_time.ge("${this.getStartTimeFilter()}")`, `id.not_in(${this.data.process_instance_id || this.data.id})`, `process_definition_key.equals(${this.data.variables.process_definition_key})`],
        },
      }).then(res => {
        this.tableData = res.data?.data || []
        this.tablePage.total = res.data?.total || 0
      })
    },
    getStartTimeFilter () {
      const map = {
        '24h': { value: 24, unit: 'hours' },
        '7d': { value: 7, unit: 'days' },
        '30d': { value: 30, unit: 'days' },
      }
      const config = map[this.alertTime] || map['24h']
      return this.$moment().utc().subtract(config.value, config.unit).format('YYYY-MM-DD HH:mm:ss')
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      const offset = (currentPage - 1) * pageSize
      this.getAlertList(offset)
    },
  },
}
</script>

<style lang="scss">
.emphasize {
  color: #f5222d;
  font-size: 16px;
}
.second {
  color: #999;
  font-size: 12px;
}
</style>
